import React from 'react';
import { toast } from 'react-toastify';
import InvoiceRenderer from '../components/invoice/InvoiceRenderer';
import { BaseInvoiceDTO, CreateInvoiceDTO, ProjectData } from '../components/invoice/invoice.type';

export interface InvoicePageProps {
  // This component can be used for any type of report or entity
  // The parent component should pass all necessary data
  reportData?: {
    id: string;
    name?: string;
    project?: ProjectData;
  };
  invoices?: BaseInvoiceDTO[];
  onAddInvoice?: (invoice: CreateInvoiceDTO) => void;
  onDeleteInvoice?: (invoiceId: string) => void;
  onExportInvoice?: (invoice: CreateInvoiceDTO) => void;
  onExportPastInvoice?: (invoice: CreateInvoiceDTO) => void;
  title?: string;
  isExportMode?: boolean;
  service?: string;
  isMonitoringReport?: boolean;
}

const InvoicePage: React.FC<InvoicePageProps> = ({
  reportData,
  invoices = [],
  onAddInvoice,
  onDeleteInvoice,
  onExportInvoice,
  onExportPastInvoice,
  title = 'Export Invoice',
  isExportMode = true,
  service = '',
  isMonitoringReport = false,
}) => {
  const handleAddInvoice = (invoiceData: CreateInvoiceDTO) => {
    if (onAddInvoice) {
      onAddInvoice(invoiceData);
    } else {
      toast.success('Invoice functionality will be implemented separately');
    }
  };

  const handleDeleteInvoice = (invoiceId: string) => {
    if (onDeleteInvoice) {
      onDeleteInvoice(invoiceId);
    } else {
      toast.success('Invoice deletion functionality will be implemented separately');
    }
  };

  const handleExportInvoice = (invoiceData: CreateInvoiceDTO) => {
    if (onExportInvoice) {
      onExportInvoice(invoiceData);
    } else {
      toast.success('Invoice export functionality will be implemented separately');
    }
  };

  const handleExportPastInvoice = (invoiceData: CreateInvoiceDTO) => {
    if (onExportPastInvoice) {
      onExportPastInvoice(invoiceData);
    } else {
      toast.success('Past invoice export functionality will be implemented separately');
    }
  };

  const projectData = reportData?.project
    ? {
        projectNumber: reportData.project.projectNumber,
        projectTitle: reportData.project.projectTitle,
        clientName: reportData.project.clientName,
        clientAddress: reportData.project.clientAddress,
        projectAddress: reportData.project.projectAddress,
      }
    : undefined;

  return (
    <InvoiceRenderer
      invoices={invoices}
      onAddInvoice={handleAddInvoice}
      onDeleteInvoice={handleDeleteInvoice}
      projectData={projectData}
      isExportMode={isExportMode}
      onExportInvoice={handleExportInvoice}
      onExportPastInvoice={handleExportPastInvoice}
      title={title}
      service={service}
      isMonitoringReport={isMonitoringReport}
    />
  );
};

export default InvoicePage;
